// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const useStickyfill = require('client-v2/common/hooks/stickyfill')
// Sibling imports
const TopCallToActionExplainer = require('./explainer')
const TopCallToActionJumpToGrid = require('./jump-to-grid')

const bem = BemEntity('TopCallToActionExperimentBSplitLeading')

function TopCallToActionExperimentBSplitLeading(props) {
  return tag('div', {
    ref: props.forwardedRef,
    className: classNames(
      bem.block(),
      props.className
    )
  },
    tag('div', {
      className: bem.element('sticky-wrapper')
    },
      tag('div', {
        ref: useStickyfill(),
        className: bem.element('logo-icon')
      })
    ),
    tag('div', {
      className: bem.element('sticky-wrapper')
    },
      tag('div', {
        ref: useStickyfill(),
        className: bem.element('logo-text')
      })
    ),
    tag('div', {
      className: bem.element('sticky-wrapper')
    },
      tag(TopCallToActionExplainer, {
        forwardedRef: useStickyfill(),
        className: bem.element('explainer')
      })
    ),
    tag('div', {
      className: bem.element('sticky-wrapper')
    },
      tag(TopCallToActionJumpToGrid, {
        forwardedRef: useStickyfill(),
        className: bem.element('jump-to-grid'),
        href: '#discover'
      })
    )
  )
}

module.exports = TopCallToActionExperimentBSplitLeading
